import { Dropdown } from "antd";
import React from "react";
import { FiChevronDown } from "react-icons/fi";
import { GenericBankFeedsAccountName } from "../GenericBankFeedsAccountName";

export const DropdownContents = React.memo(
  ({
    overlay,
    disabled,
    bfAccountId,
    onVisibleChange,
    glAccountDropdownLabel,
  }: {
    overlay: React.ReactElement;
    disabled: boolean;
    bfAccountId: string;
    onVisibleChange: (visible: boolean) => void;
    glAccountDropdownLabel: string;
  }) => {
    return (
      <Dropdown
        overlay={overlay}
        onVisibleChange={onVisibleChange}
        disabled={disabled}
        trigger={["click"]}>
        <a
          onClick={(e) => e.preventDefault()}
          style={{
            outline: "1px solid #d3d3d3",
            outlineOffset: 2,
            borderRadius: 4,
            padding: "2px 8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            width: "200px",
          }}>
          <div
            style={{
              fontSize: 12,
              maxWidth: "170px",
              whiteSpace: "nowrap",
              overflow: "visible",
              textOverflow: "ellipsis",
            }}>
            <GenericBankFeedsAccountName
              id={"selected_" + bfAccountId}
              text={glAccountDropdownLabel}
            />
          </div>
          <div style={{ marginLeft: "auto" }}>
            <FiChevronDown></FiChevronDown>
          </div>
        </a>
      </Dropdown>
    );
  },
);
